import ServiceSDK from './dist/service-sdk';

export default ServiceSDK;
